export enum HrCategoryEn {
  BT_TICKET = 'BT_TICKET', //Phiếu Công tác
  TRANS_TICKET = 'TRANS_TICKET', //Phiếu Vận chuyển
  AP_TICKET = 'AP_TICKET', //Phiếu Ứng tiền
  PR_TICKET = 'PR_TICKET', //Phiếu đề nghị mua hàng
  LV_TICKET = 'LV_TICKET', //Phiếu Nghỉ phép
  OT_TICKET = 'OT_TICKET', //Phiếu Tăng ca
  ESR_TICKET = 'ESR_TICKET', //Phiếu yêu cầu cấp thiết bị
  VT_TICKET = 'VT_TICKET', //Về trễ
  LV_PACKAGE = 'LV_PACKAGE', //Nghỉ phép - Package
  AWT_PACKAGE = 'AWT_PACKAGE' //Bổ sung giờ làm
}
